import BulkActionsDrawerItem from "components/BulkActions/Drawer/Item";
import BulkActionsDrawerItemLink from "components/BulkActions/Drawer/Item/Link";
import BulkActionsDrawerItemStatusIcon from "components/BulkActions/Drawer/Item/StatusIcon";
import BulkActionsDrawerItemStopExecutionButton from "components/BulkActions/Drawer/Item/StopExecutionButton";
import { BulkActionResultsMetadataMap } from "components/BulkActions/helpers";
import {
  BulkActionResultTabs,
  BulkActionsResult,
  BulkActionsStep,
} from "components/BulkActions/types";
import { Stack as StackIcon } from "components/icons/generated";
import Box from "ds/components/Box";
import Feedback from "ds/components/Feedback";
import Link from "ds/components/Link";
import { Run, Stack } from "types/generated";

type StackRunsBulkActionsResultItemProps = {
  stack: Stack;
  item: Run;
  tab: BulkActionResultTabs;
  resultsMetadata: BulkActionResultsMetadataMap;
  status: BulkActionsResult;
  stopExecution: () => void;
};

const StackRunsBulkActionsResultItem = ({
  stack,
  item,
  tab,
  resultsMetadata,
  status,
  stopExecution,
}: StackRunsBulkActionsResultItemProps) => {
  const feedbackVariant = status === BulkActionsResult.Failed ? "danger" : "info";

  return (
    <BulkActionsDrawerItem key={item.id} direction="column" align="start">
      <Box align="center" gap="medium" fullWidth zeroMinWidth>
        <Box direction="column" gap="small" fullWidth>
          <Box align="center" gap="small" fullWidth>
            <BulkActionsDrawerItemStatusIcon result={status} />
            <BulkActionsDrawerItemLink
              link={`/stack/${stack.id}/run/${item.id}`}
              text={item.title}
              step={BulkActionsStep.Results}
              itemCategory={tab}
            />
          </Box>
          <Link href={`/stack/${stack.id}`} startIcon={StackIcon} variant="primary">
            {stack.name}
          </Link>
        </Box>
        <BulkActionsDrawerItemStopExecutionButton onStopExecution={stopExecution} status={status} />
      </Box>

      {resultsMetadata.get(item.id)?.message && (
        <Feedback type="banner" variant={feedbackVariant} fullWidth>
          {resultsMetadata.get(item.id)?.message}
        </Feedback>
      )}
    </BulkActionsDrawerItem>
  );
};

export default StackRunsBulkActionsResultItem;
